import { Provider } from 'react-redux';
import { redux_store } from '../redux/store';
import { ReactElement, ReactNode } from 'react';

type Children_Type = ReactNode | ReactElement;

interface Component_Prop_Type {
  children: Children_Type;
}

function ReduxStoreProvider({ children }: Component_Prop_Type) {
  return <Provider store={redux_store}>{children}</Provider>;
}

export default ReduxStoreProvider;
